import './permanently-delete-customer.dialog.component.scss'
import {Customer} from "../../model/Customer";
import {CustomerServiceName} from "../../../utils/names/serviceNames";
import "angular-material/index";
import {CustomerService} from "../../../customer_service/service/CustomerService";

export class PermanentlyDeleteCustomerDialog {

    static instance = (customer: Customer) => ({
        controller: [
            'customer',
            '$mdDialog',
            CustomerServiceName,
            PermanentlyDeleteCustomerDialog
        ],
        template: require('./permanently-delete-customer.dialog.component.html'),
        locals: {
            customer: customer
        },
        bindings: {
             customer: '<'
        },
        clickOutsideToClose: true,
        controllerAs: '$ctrl',
        bindToController: true
    });

    constructor(private customer: Customer,
                private $mdDialog: angular.material.IDialogService,
                private customerService: CustomerService) {

    }

    delete = () => {
        this.customerService.permanentlyDeleteCustomer(this.customer.id)
            .then(resp => this.$mdDialog.hide(resp));
    };

    cancel = () => {
        this.$mdDialog.cancel();
    };

}